import { render, staticRenderFns } from "./MxApplicant.vue?vue&type=template&id=032a77a0"
import script from "./MxApplicant.vue?vue&type=script&lang=js"
export * from "./MxApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports